import React from "react";
import Header from "../../../Components/Common/Header";
import ManageRecipeNew from "./ManageRecipeNew";
import ManageRecipeCard from "../../../Components/Apps/ManageRecipeCard";

class ManageRecipe extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCompose: false,
      show: false,
    };
  }

  handleNewButtonClick = () => {
    this.setState({ show: true });
  };

  handleCancelNew = () => {
    this.setState({ show: false });
  };

  render() {
    return (
      <div className="container-fluid">
        {!this.state.show && (
          <Header
            headerText=""
            mainNavigate="Manage Recipe"
            currentPage="Manage Recipe"
            childNav={this.state.isCompose ? "Compose" : ""}
          />
        )}
        <div className="row clearfix ">
          {!this.state.show && (
            <div className="container mx-2 mb-2">
              <div className="d-flex justify-content-between">
                <div>
                  <h4>Manage Recipe</h4>
                </div>

                <div className="d-flex">
                  <div className="">
                    {!this.state.show && (
                      <button
                        className="btn btn-primary px-2 py-2"
                        onClick={this.handleNewButtonClick}
                      >
                        + NEW
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
          {this.state.show ? (
            <ManageRecipeNew handleCancle={this.handleCancelNew} />
          ) : (
            <ManageRecipeCard />
          )}
        </div>
      </div>
    );
  }
}
export default ManageRecipe;
